import { Controller } from "stimulus"
import RequestQueue from 'classes/RequestQueue';
import _ from 'lodash';

var modal;

class InfoPopupModal extends Controller {
  static targets = [
    'modalTrigger',
    'modalContainer'
  ];

  static values = {
    id: String
  }
  
  async connect() {
  }

  // Fetches the modal html from component
  async __fetchModalData() {
    const data = this.element.getAttribute('data-modal-params') || '{}';
    const url = this.element.getAttribute('data-modal-url');
    const slug = this.element.getAttribute('data-modal-slug');
    const name = this.element.getAttribute('data-modal-name');
    const resource = this.element.getAttribute('data-resource');

    try {
      return await await RequestQueue.addToQueue({
        method: 'post',
        url: url,
        data: {
          property: window.websiteProperty,
          data,
          name,
          slug,
          resource: JSON.parse(resource || '{}')
        },
        cached: true
      })
    } catch(e) {
      console.log(e);
      return {};
    }
  }

  async appendModal(data) {
    const parser = new DOMParser();
    const fragment = parser.parseFromString(data, 'text/html').body;
    const firstChild = fragment.firstElementChild || document.createElement('div');
    this.element.setAttribute('data-info-popup-modal-target', 'modalTrigger');
    document.getElementById(this.idValue).parentNode.append(firstChild);
  }

  async showModal(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();

    if(this.hasModalTriggerTarget) {
      modal.modalContainerTarget.classList.add('active');
    } else {
      const { data } = await this.__fetchModalData();
      this.appendModal(data);
    }
  }

  async closeModal(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();

    modal = this;

    if(this.hasModalContainerTarget) {
      this.modalContainerTarget.classList.remove('active');
    }
  }
}

export default InfoPopupModal;
